import { useHttp } from '@/shared/lib'
import { computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { useRoute } from 'vue-router'

/**
 * Object types for the **current** inventory object (route `object_id`).
 * A hardcoded `/inventory/objects/1/…` breaks group-scoped admin (e.g. passport builder header).
 */
export const useLoadWidgetObjectTypes = () => {
  const http = useHttp()
  const route = useRoute()

  const inventoryObjectId = computed(() => {
    const raw = route.params.object_id
    if (raw == null) return '1'
    const s = String(raw).trim()
    return s !== '' ? s : '1'
  })

  const url = computed(() => `/inventory/objects/${inventoryObjectId.value}/object-types`)

  return useQuery({
    queryKey: ['load_widget_object_types', inventoryObjectId.value],
    queryFn: () => http.get(url.value),
    retry: false,
  })
}
